import { TRAVEL_INSURANCE_FORM } from '../../../actions/travelKe/quote';
import { quoteFormValidation } from './quote';

import { TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALUE } from '../../../actions/travelKe/personalDetails';
import { travelDetailsValidation } from './travel';

import { MOTOR_INSURANCE_AGENT_MODAL_DETAILS_SET_VALUE } from '../../../actions/travelKe/motorAgentModal';
import { agentModalFormValidation } from './travelAgentModal';

import { MOTOR_INSURANCE_NEXT_OF_KIN_FORM_SET_VALUE } from '../../../actions/travelKe/nextOfKin';
import { nextOfKinValidation } from './nextOfKin';

import { PAYMENTS_SET_VALUE } from '../../../actions/travelKe/payments';
import { paymentsFormValidation } from './payments';

import { SET_SHARE_EMAIL_VALUE } from '../../../actions/travelKe/quote';
import { shareQuoteValidation } from './shareQuote';

export const travelKeValidation = (store, next, action) => {
    if (action.type.startsWith(TRAVEL_INSURANCE_FORM)) {
        return quoteFormValidation(store, next, action);
    }
    if (action.type.startsWith(TRAVEL_INSURANCE_TRAVEL_DETAILS_FORM_SET_VALUE)) {
        return travelDetailsValidation(store, next, action);
    }
    if (action.type.startsWith(PAYMENTS_SET_VALUE)) {
        return paymentsFormValidation(store, next, action);
    }
    if (action.type.startsWith(MOTOR_INSURANCE_NEXT_OF_KIN_FORM_SET_VALUE)) {
        return nextOfKinValidation(store, next, action);
    }
    if (action.type.startsWith(SET_SHARE_EMAIL_VALUE)) {
        return shareQuoteValidation(store, next, action);
    }
    if (action.type.startsWith(MOTOR_INSURANCE_AGENT_MODAL_DETAILS_SET_VALUE)) {
        return agentModalFormValidation(store, next, action);
    }

    return null;
};
